import * as React from "react";
import styled from "styled-components";
import { TargetLine } from "./TargetLine";

export const HorizontalProgressBar: React.FC<HorizontalProgressBarProps> = ({
    value,
}) => {
    if (value === null) {
        return null;
    }

    return (
        <ProgressBarWrapper>
            <DotRail />
            <TargetLine
                color="orange"
                style={{ left: `${GetZoomedPosition(75, value)}%` }}
            />
            <TargetLine
                color="#ff0000"
                style={{ left: `${GetZoomedPosition(87.5, value)}%` }}
            />
        </ProgressBarWrapper>
    );
};

interface HorizontalProgressBarProps {
    value: number | null; // A value between 0 and 100
}

function GetZoomedPosition(target: number, value: number) {
    return (target - value + 10) * (100 / 20);
}

const ProgressBarWrapper = styled.div`
    height: 8px;
    position: relative;
    width: 336px;
    margin: 0 auto;
    mask-image: linear-gradient(
        to right,
        transparent 0,
        black 12%,
        black calc(50% - 12px),
        transparent calc(50% - 8px),
        transparent calc(50% + 8px),
        black calc(50% + 12px),
        black 88%,
        transparent 100%
    );
    opacity: 0.65;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(
        to right,
        transparent 0,
        black 12%,
        black calc(50% - 12px),
        transparent calc(50% - 8px),
        transparent calc(50% + 8px),
        black calc(50% + 12px),
        black 88%,
        transparent 100%
    );
`;

const DotRail = styled.div`
    background-image:
        radial-gradient(
            circle,
            rgba(197, 174, 126, 0.72) 0,
            rgba(197, 174, 126, 0.72) 1px,
            transparent 1.2px
        ),
        radial-gradient(
            circle,
            rgba(224, 198, 139, 0.9) 0,
            rgba(224, 198, 139, 0.9) 1.2px,
            transparent 1.4px
        );
    background-position: left center;
    background-repeat: repeat-x;
    background-size:
        10px 2px,
        50px 2px;
    height: 2px;
    left: 0;
    position: absolute;
    right: 0;
    top: 3px;
`;
